import { ReactElement } from 'react';

import { Notification, NotificationSize, NotificationType } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

export const MedicineOutdatedNotification = (): ReactElement => {
   return (
      <Notification
         testId={'medicineOutdated'}
         type={NotificationType.INFO}
         label={translationKeys.medicineWithdrawn}
         size={NotificationSize.SMALLEST}
      />
   );
};
